export default __webpack_public_path__ + "static/media/CivilEng_IMG-TNB.d150c93b.png";